import React, { useState, useEffect } from 'react';

const LoadingAnimation = () => {
  const [dotCount, setDotCount] = useState(0);
  const [messageIndex, setMessageIndex] = useState(0);

  const loadingMessages = [
    "正在识别图片中的美食",
    "正在分析菜品成分",
    "马上就好",
    "正在检查菜品",
    "快要完成了"
  ];

  useEffect(() => {
    // 处理动画点的变化
    const dotInterval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);

    // 处理消息的变化
    const messageInterval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 2000);

    return () => {
      clearInterval(dotInterval);
      clearInterval(messageInterval);
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-6">
      {/* 主要动画 */}
      <div className="relative">
        {/* 外圈动画 */}
        <div className="absolute inset-0 animate-spin-slow">
          <div className="h-16 w-16 rounded-full border-4 border-green-500 border-t-transparent"></div>
        </div>
        
        {/* 内圈动画 */}
        <div className="absolute inset-0 animate-spin-reverse-slow">
          <div className="h-16 w-16 rounded-full border-4 border-green-300 border-b-transparent"></div>
        </div>

        {/* 中心图标 */}
        <div className="relative h-16 w-16 flex items-center justify-center">
          <svg className="w-8 h-8 text-green-500 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
          </svg>
        </div>
      </div>

      {/* 加载消息 */}
      <div className="text-center space-y-2">
        <p className="text-lg text-gray-700 font-medium">
          {loadingMessages[messageIndex]}
          <span className="inline-block w-8">
            {'.'.repeat(dotCount)}
          </span>
        </p>
        <p className="text-sm text-gray-500">
          请稍等片刻，我们正在处理您的图片
        </p>
      </div>

      {/* 装饰性动画元素 */}
      <div className="flex space-x-2">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 rounded-full bg-green-500 animate-pulse`}
            style={{ animationDelay: `${i * 200}ms` }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default LoadingAnimation; 